import React from 'react';
import Box from '@mui/material/Box';
import TicketForm from '../../ticketForm/TicketForm';

interface ActiveVehicleDrawerProps {}

const ActiveVehicleDrawerTicketStage: React.FC<
	ActiveVehicleDrawerProps
> = ({}) => {
	return (
		<>
			<Box
				style={{
					display: 'flex',
					justifyContent: 'center',
				}}
			>
				<TicketForm />
			</Box>
		</>
	);
};

export default ActiveVehicleDrawerTicketStage;
